
angular.module('trainerWebApp.resources').factory('CustomizeResource', ['$resource', 'errorHandler', function ($resource, errorHandler) {

  var CustomizeResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/course/:courseId/setting/:type');

  CustomizeResource.prototype.getCourseSettings = function (courseId, resultCb, errorCb) {
    return CustomizeResource.get({courseId: courseId}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
  };

  CustomizeResource.prototype.updateCertificateSettings = function (courseId, certificateStatus, certificateQuizStatus, certificateTemplate, resultCb, errorCb) {
    if (!this.validId(courseId))
      throw new Error("Series id is invalid.");

    return CustomizeResource.save({courseId: courseId,  type: 'certificate'},
      {certificateStatus: certificateStatus, certificateQuizStatus: certificateQuizStatus, certificateTemplate: certificateTemplate},
      resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
  };

  CustomizeResource.prototype.updateCourseRetakeEnabled = function (courseId, reTakeEnabled, resultCb, errorCb) {
    if (!this.validId(courseId))
      throw new Error("Series id is invalid.");

    return CustomizeResource.save({courseId: courseId,  type: 'retake'},
      {reTakeEnabled: reTakeEnabled},
      resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
  };

  CustomizeResource.prototype.updateSensionUsage = function (courseId, sensionUsage, resultCb, errorCb) {
    if (!this.validId(courseId))
      throw new Error("Series id is invalid.");

    return CustomizeResource.save({courseId: courseId,  type: 'sension'},
      {sensionUsage: sensionUsage},
      resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
  };

  CustomizeResource.prototype.updateCourseShareSettings = function updateCourseShareSettings(courseId, courseAccessType, yammerSharesEnabled, resultCb, errorCb) {
    return CustomizeResource.save({courseId: courseId,  type: 'share'},
      {courseAccessType: courseAccessType,
       yammerSharesEnabled: yammerSharesEnabled},
      resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
  };


  CustomizeResource.prototype.updateCoursePassingScoreSettings = function updateCoursePassingScoreSettings(courseId, hasPassingScore, passingScore, resultCb, errorCb) {
    return CustomizeResource.save({courseId: courseId,  type: 'passingScore'},
      {hasPassingScore: hasPassingScore, passingScore: passingScore},
      resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
  };


  CustomizeResource.prototype.updateCourseReminderSettings = function updateCourseReminderSettings(courseId, reminderActive, reminderInterval, resultCb, errorCb) {
    if (!this.validId(courseId))
      throw new Error("Series id is invalid.");

    return CustomizeResource.save({courseId: courseId, type: 'reminder'},
      {reminderActive: reminderActive, reminderInterval: reminderInterval},
      resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
  };

  CustomizeResource.prototype.updateCourseDeadlineSettings = function updateCourseDeadlineSettings(courseId, courseDeadlineLength, courseDeadlineUnit, resultCb, errorCb) {
    if (!this.validId(courseId))
      throw new Error("Series id is invalid.");

    return CustomizeResource.save({courseId: courseId, type: 'deadline'},
      {courseDeadlineLength: courseDeadlineLength, courseDeadlineUnit: courseDeadlineUnit},
      resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
  };

  CustomizeResource.prototype.validId = function(value) {
    value = +value;
    if(isNaN(value)) return false;
    if(!angular.isNumber(value)) return false;
    if(value <= 0) return false;
    return true;
  };

  // return an instance of our constructed resource
  // we could do something similar with a service
  // and just return this but we want to 'new' it
  return new CustomizeResource;
}]);
